<template>
  <div class="skeleton" />
</template>

<style lang="scss" scoped>
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.skeleton {
  width: 100%;
  height: 496px;
  background-color: $global-white;
  border-radius: $border-radius;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
